<template>
  <b-modal title="SGC" 
      v-model="modalVisible" 
      :header-bg-variant="modalVariant"
      ok-only 
      ok-variant="primary footer-button"
      @ok="okAction" 
      @hidden="hiddenAction">
    {{ modalMensaje }}
  </b-modal>
</template>

<script>
export default {
  props: {
    modalMsj: {
      type: Boolean,
      default: false
    },
    modalMensaje: {
      type: String,
      default: ''
    },
    modalVariant: {
      type: String,
      default: 'light'
    }
  },
  computed: {
    modalVisible: {
      get: function () {
        return this.modalMsj;
      },
      set: function (newValue) {}
    },    
  },
  methods: {
    okAction() {
      this.$emit('okAction');
    },
    hiddenAction() {
      this.$emit('hiddenAction');
    }
  }
}
</script>

<style>
</style>
